import React from 'react';
import { StyledBody } from '../../CSSstyles';
import { getScreeningRequiredCopy } from '../../util';

type Props = {
  requirements?: any[];
};

const ScreeningRequiredBulletPoint = ({ requirements }: Props) => {
  return (
    <li>
      <StyledBody>{getScreeningRequiredCopy(requirements)}</StyledBody>
    </li>
  );
};

export default ScreeningRequiredBulletPoint;
